export const tryParseJson = <T>(json: string | undefined): T | undefined => {
  if (!json) return undefined;

  try {
    return JSON.parse(json) as T;
  } catch (e) {
    return undefined;
  }
};
